export default __webpack_public_path__ + "static/media/Soulcrush.8f749d25.jpg";